import { formatValue } from './lib/formatValue';

export function SpeedHud({ speed }) {
	return (
		<div className='absolute left-1/2 top-[10px] flex -translate-x-1/2 transform flex-col'>
			<div
				className='relative -top-[2px] w-[180px] bg-transparent p-0 text-center font-[Arial] font-[1000] capitalize text-white'
				style={{ fontSize: speed >= 100 ? '75px' : '95px' }}
			>
				{formatValue(speed) || '-'}
			</div>
			<div className='w-[180px] bg-transparent p-0 text-center font-[Arial] text-[20px] font-bold leading-[0] text-white/50'>
				km/h
			</div>
		</div>
	);
}
